/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "0.0.1",
  "gitBuildTime": "2023-03-13T15:40:53.565Z",
  "gitBuildVersion": "0.0.1",
  "gitCommitId": "6f3db60",
  "gitCommitIdFull": "6f3db60dcdc660a30c6af233229988e87b5a641e",
  "gitCommitTime": "2023-03-13T15:31:17.000Z",
  "version": "0.0.1-2023-03-13T15:31:17.000Z-(6f3db60)"
};
